import React from 'react';
import PropTypes from 'prop-types';
// import Fab from '@material-ui/core/Fab';
import ClearIcon from '@mui/icons-material/Clear';
import VideocamIcon from '@mui/icons-material/Videocam';
import { getVideoId } from 'helpers';
import { VideoContainer, CloseBtn, LinkContainer, useClasses } from './style';

const getHeight = width => {
  return (width * 45) / 80;
};

const VideoPreview = ({ id, value, onRemoveClick, width }) => {

  const classes= useClasses();

  const removeClickHandler = () => {
    onRemoveClick(id);
  };

  let parsedValue = null;
  if (value) {
    const videoId = getVideoId(value);
    if (videoId && videoId.type === 'YOUTUBE') {
      parsedValue = (
        
        <iframe
          className={classes.video}
          title={videoId.value}
          width={width}
          height={getHeight(width)}
          src={`https://www.youtube.com/embed/${videoId.value}`}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
      
    } else if (videoId && videoId.type === 'VIMEO') {
      parsedValue = (
        <iframe
          title={videoId.value}
          src={`https://player.vimeo.com/video/${videoId.value}`}
          width={width}
          height={getHeight(width)}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
        // </div>
      );
    }
  }

  return (
    <>
      <VideoContainer fullWidth={!parsedValue}>
        {parsedValue || (
          <LinkContainer>
 
            <a
              key={id}
              href={value.indexOf('http') === 0 ? value : `http://${value}`}
              target="_blank"
              rel="noopener noreferrer"
            >
               <VideocamIcon />{value}
            </a>
          </LinkContainer>
        )}
        {onRemoveClick && (
          <CloseBtn size="small" color="primary" aria-label="Remove" onClick={removeClickHandler}>
            <ClearIcon />
          </CloseBtn>
        )}
      </VideoContainer>
    </>
  );
};

VideoPreview.propTypes = {
  onChange: PropTypes.func,
  width: PropTypes.number,
};

VideoPreview.defaultProps = {
  width: 400,
  onChange: undefined,
};

export default VideoPreview;
